module.exports = __webpack_public_path__ + "static/internet-a25b767b10adbbe4d94ef13dd29c508f.mp4";